export default __webpack_public_path__ + "static/media/Mark-6-HUD-RT Output.1ef1918d.jpg";